import React, { type ReactNode } from 'react';

import Heading from '@atlaskit/heading/heading';
import HeadingContextProvider from '@atlaskit/heading/heading-context/default';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import { token } from '@atlaskit/tokens';

const cardStyles = xcss({
	display: 'flex',
	gap: 'space.200',
	padding: 'space.200',
	backgroundColor: 'color.background.neutral',
	borderWidth: 'border.width',
	borderStyle: 'solid',
	borderColor: 'color.border',
});

const RadiusCard = ({
	heading,
	children,
}: {
	heading: Extract<Parameters<typeof token>[0], 'radius.xlarge' | 'radius.large' | 'radius.small'>;
	children?: ReactNode;
}) => {
	const radiusMap = {
		'radius.xlarge': token('radius.xlarge'),
		'radius.large': token('radius.large'),
		'radius.small': token('radius.small'),
	};

	return (
		<HeadingContextProvider>
			<Box xcss={cardStyles} style={{ borderRadius: radiusMap[heading] }}>
				<Heading size="xsmall">{heading}</Heading>
				{children}
			</Box>
		</HeadingContextProvider>
	);
};

const Cards = (): React.JSX.Element => (
	<RadiusCard heading="radius.xlarge">
		<RadiusCard heading="radius.large">
			<RadiusCard heading="radius.small" />
		</RadiusCard>
	</RadiusCard>
);

export default Cards;
